module.exports = __webpack_public_path__ + "static/daa63c725150d29cb7d47485f8317812ebcb79e1b819745788dd52d8d9fb62b5-4c8c213574bd6e130e058b835fb9a25c.png";